import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import isNil from 'lodash/isNil';
import { ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT, formatters } from 'common';
import DefListColumn from 'components/DefListColumn';
import styles from './styles.css';
import messages from './messages';

const IncomingWiresAccountPanel = ({
  correspondentName,
  accountOpenedDate,
  apexAccountNumber,
  beneficiaryName,
  beneficiaryAddress,
  onEditAccountButtonClicked,
  allowEditAccount,
}) => {
  const todayDate = moment().format(ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT);
  const sixtyDaysAgoDate = moment().subtract(60, 'days').format(ACCOUNTS_UI_SEARCH_QUERYPARAM_DATE_FORMAT);

  const accountNumberData = () => {
    let data = apexAccountNumber;
    if (allowEditAccount) {
      const hasAccountNum = !isNil(apexAccountNumber) && apexAccountNumber !== '';
      data = (
        <span>
          {apexAccountNumber}
          <button
            bsStyle="link"
            id="#editAccount"
            className="button-link"
            onClick={onEditAccountButtonClicked}
            data-test-handle="editAccountButton"
          >
            {hasAccountNum
              ? <FormattedMessage {...messages.editAccount} />
              : <FormattedMessage {...messages.enterAccount} />}
          </button>
        </span>
      );
    }
    return data;
  };

  return (
    <div className={styles.panel}>
      <div className={styles.leftPane}>
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.accountData} />}
          data={accountNumberData()}
          dataTestHandle="transferPanel__accountData"
        />
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.beneficiaryName} />}
          data={beneficiaryName}
          dataTestHandle="transferPanel__beneficiaryName"
        />
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.beneficiaryAddress} />}
          data={beneficiaryAddress}
          dataTestHandle="transferPanel__beneficiaryAddress"
        />
      </div>
      <div className={styles.rightPane}>
        <DefListColumn
          className={styles.longDataDefList}
          title={<FormattedMessage {...messages.correspondent} />}
          data={formatters.formatCorrespondentName(correspondentName)}
          dataTestHandle="transferPanel__correspondent"
        />
        <DefListColumn
          className={styles.defList}
          title={<FormattedMessage {...messages.openedDate} />}
          data={accountOpenedDate}
          dataTestHandle="transferPanel__openedDate"
        />
        {/* adding skipSearch prevents the query params from being overwritten when going to accounts */}
        <a className={styles.accountsUILink} href={`/accounts/#/${apexAccountNumber}/activity?startDate=${sixtyDaysAgoDate}&endDate=${todayDate}&skipSearch=true`} target="_blank" >
          <FormattedMessage {...messages.viewAccountActivity} />
        </a>
      </div>
    </div>
  );
};

IncomingWiresAccountPanel.propTypes = {
  correspondentName: PropTypes.string.isRequired,
  accountOpenedDate: PropTypes.string.isRequired,
  apexAccountNumber: PropTypes.string.isRequired,
  beneficiaryName: PropTypes.string,
  beneficiaryAddress: PropTypes.string,
  onEditAccountButtonClicked: PropTypes.func.isRequired,
  allowEditAccount: PropTypes.bool.isRequired,
};

IncomingWiresAccountPanel.defaultProps = {
  beneficiaryName: '',
  beneficiaryAddress: '',
};


export default IncomingWiresAccountPanel;



// WEBPACK FOOTER //
// ./src/components/AccountPanel/IncomingWiresAccountPanel.js